import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=232c1d15&scoped=true&"
import script from "./mainLayout.vue?vue&type=script&lang=js&"
export * from "./mainLayout.vue?vue&type=script&lang=js&"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=232c1d15&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c1d15",
  null
  
)

export default component.exports